import React, { useRef } from 'react';
import { useOnScreen, useQuestionLive } from '@lib/livePolls/useQuestionLive';
import { LivePollCard } from './LivePollCard';

export interface LivePollFeedCardProps {
  questionId: string;
  /** The viewer may answer here (signed in); signed out the card reads only. */
  canAnswer: boolean;
  /** Drawn until the first read lands (the question and the Live pill). */
  placeholder: React.ReactNode;
  /** The card can open the poll (a feed; not the sheet or the post page): ended, it shows 2 questions and "See all". */
  onOpen?: () => void;
  openerProps?: React.HTMLAttributes<HTMLElement>;
}

/**
 * A started live poll in a feed, for anyone but its author, who gets it only once it ended (TECH-867 L6, L7, L8,
 * L15; the author's running card is FE-L1b's L9): follows the open question through `GET /questions/{id}/live` every 2 s, only while the card is
 * on screen (IntersectionObserver), and answers through the vote route with `position`.
 */
export const LivePollFeedCard: React.FC<LivePollFeedCardProps> = ({
  questionId,
  canAnswer,
  placeholder,
  onOpen,
  openerProps,
}) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const onScreen = useOnScreen(rootRef);
  const { read, answering } = useQuestionLive(questionId, onScreen);
  return (
    <div ref={rootRef} data-testid="live-poll-feed-card">
      {read ? (
        <LivePollCard
          state={read.state}
          me={read.me}
          answering={canAnswer ? answering : undefined}
          onSeeAll={onOpen}
          seeAllProps={openerProps}
        />
      ) : (
        placeholder
      )}
    </div>
  );
};
